import { arrayOfStringsToStringWithSeparator } from './string';

export function oneLineAddress(customer = {}) {
    return arrayOfStringsToStringWithSeparator([
        arrayOfStringsToStringWithSeparator([customer.address, customer.address2], ' '),
        customer.city,
        arrayOfStringsToStringWithSeparator([customer.state, customer.zip], ' ')
    ], ', ');
}
